import React from "react";
import ProfileImage from "../../assets/images/ProfileImage.png";
import styles from "./UserPanel.module.scss";
import UserPanelLink from "../UserPanelLink/UserPanelLink";
import { useAuth } from "../PrivateRoute/PrivateRoute";

const UserPanel = () => {
  const { userData, isLoading, isAuthenticated } = useAuth();

  return (
    <div className={styles.userPanel}>
      <div>
        <figure className={styles.userImageSection}>
          <img src={ProfileImage} alt="" className={styles.userImage} />
          <figcaption className={styles.userPosition}>VicePresident</figcaption>
        </figure>
      </div>
      <div className={styles.userDetails}>
        <h2>
          {userData?.first_name} {userData?.last_name}
        </h2>
        <p className={styles.role}>{userData?.role}</p>
        <p className={styles.package}>
          Пакет : <span>{userData?.subscription?.plan_name}</span>
        </p>
      </div>
      <UserPanelLink userData={userData} />
    </div>
  );
};

export default UserPanel;
